module.exports = __webpack_public_path__ + "static-appopensalud/img/pacientes-como-tu-azul.eb2eae7.svg";


//////////////////
// WEBPACK FOOTER
// ./static-appopensalud/img/logos/pacientes-como-tu-azul.svg
// module id = 1052
// module chunks = 116